import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { isModeMaintenance } from '../../../graph-ql/admin/admin.queries';

@Injectable()
export class AdminService {

  constructor(public apollo: Apollo) {
  }

  isModeMaintenance$(): Observable<boolean> {
    return this.apollo.query<boolean>({
      query: isModeMaintenance,
      variables: {
      }
    }).pipe(map(result => {
      if (result.errors) {
        throw new Error(JSON.stringify(result.errors[0]));
      }
      return result.data['isModeMaintenance'];
    }

    ));
  }
}
